class AccordionComponent {
  constructor() {
    Object.assign(this, {
      panes: [],
      singleOpening: false,
      allClosable: true,
      toggleMode: true,
    });
  }

  select(pane) {
    if (this.singleOpening) {
      this.panes.forEach((thisPane) => {
        if (thisPane !== pane) {
          thisPane.open = false;
        }
      });
    }
    if (this.toggleMode) {
      pane.open = !pane.open;
    } else {
      pane.open = true;
    }
  }

  addPane(pane) {
    this.panes.push(pane);
  }
}

angular.module('pims')
  .component('accordion', {
    transclude: true,
    templateUrl: 'app/components/accordion/accordion.component.html',
    controller: AccordionComponent,
    controllerAs: 'vm',
    bindings: {
      singleOpening: '<?',
      allClosable: '<?',
      toggleMode: '<?',
      autoOpen: '<?',
    },
  });
